var React = require('react');

function IconSpeech (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0.115697C3.64554 0.115697 0.115077 3.232 0.115077 7.07693C0.115077 9.032 1.03077 10.7932 2.50031 12.0578C2.17969 13.9095 0.108308 14.6634 0.249846 15.1729C2.10215 15.9391 5.77046 14.1606 6.32677 13.8849C6.86462 13.9871 7.42769 14.0388 8 14.0388C12.3545 14.0388 15.8849 10.9218 15.8849 7.07693C15.8849 3.232 12.3539 0.115697 8 0.115697Z","fill":"#213042"}));
}

IconSpeech.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconSpeech;

IconSpeech.default = IconSpeech;
